import { InfiniteData, infiniteQueryOptions, UseInfiniteQueryOptions } from "@tanstack/react-query";
import { Annotation, Build, CursorPaginated } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";

export const allJobAnnotationsQueryKey = (buildId: Build["id"]) => {
  return ["build", buildId, "annotations", "jobs"];
};

type AllJobAnnotationsPage = CursorPaginated<Annotation>;
type AllJobAnnotationsPageParam = string | null;
type AllJobAnnotationsQueryKey = ReturnType<typeof allJobAnnotationsQueryKey>;

type AdditionalOptions = Omit<
  UseInfiniteQueryOptions<
    AllJobAnnotationsPage,
    Error,
    InfiniteData<AllJobAnnotationsPage, AllJobAnnotationsPageParam>,
    AllJobAnnotationsQueryKey,
    AllJobAnnotationsPageParam
  >,
  "queryKey" | "queryFn" | "initialPageParam" | "getNextPageParam"
>;

export const allJobAnnotationsQueryOptions = (build: Build, options?: AdditionalOptions) => {
  return infiniteQueryOptions({
    ...options,
    queryKey: allJobAnnotationsQueryKey(build.id),
    queryFn: ({ pageParam, signal }) =>
      fetchAllJobAnnotations(build.buildDataBasePath, pageParam, signal),
    initialPageParam: null as AllJobAnnotationsPageParam,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.endCursor : null),
  });
};

function fetchAllJobAnnotations(
  buildDataBasePath: Build["buildDataBasePath"],
  pageParam: string | null,
  signal: AbortSignal,
) {
  const url = new URL(`${buildDataBasePath}/annotations`, window.location.origin);
  url.searchParams.set("scope", "job");

  if (pageParam) {
    url.searchParams.set("after", pageParam);
  }

  return fetcher<CursorPaginated<Annotation>>(url, true, { signal });
}
